import { render, staticRenderFns } from "./EditOrderRemarkForm.vue?vue&type=template&id=bdfc041c&scoped=true"
import script from "./EditOrderRemarkForm.vue?vue&type=script&lang=js"
export * from "./EditOrderRemarkForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdfc041c",
  null
  
)

export default component.exports